'use client';

import React, { useEffect, useState } from 'react';
import { Helmet } from '../../../components/Helmet';
import { FeatureFlags } from '../../../constants/feature-flags';
import { WellnessPlansPageContainer } from '../../../containers/WellnessPlansPageContainer';
import { WellnessPlansPageContainerV2 } from '../../../containers/WellnessPlansPageContainerV2';
import { SplitTreatments } from '../../../constants/app';
import { useCanonicalUrl } from '../../../hooks/useCanonicalUrl';
import { useSegmentPage } from '../../../hooks/useSegmentPage';
import { useSplit } from '../../../hooks/useSplit';
const Index = () => {
  const {
    canonicalUrl
  } = useCanonicalUrl();
  const {
    execute: executeSegmentPage
  } = useSegmentPage();
  const {
    splitTreatment
  } = useSplit(FeatureFlags.WellnessLandingTreatment);
  const [treatment, setTreatment] = useState(splitTreatment);
  useEffect(() => {
    if (!treatment) {
      return;
    }
    executeSegmentPage({
      properties: {
        treatment
      }
    });
  }, [executeSegmentPage, treatment]);
  useEffect(() => {
    setTreatment(splitTreatment);
  }, [splitTreatment]);
  return <>
      <Helmet canonical={canonicalUrl} title="Easy Wellness Plans for Routine Pet Care | Wag!" description="Compare top-rated pet wellness plans for routine pet care. Get reimbursed for vet bills. Use any vet for any breed or age. Your plan starts instantly. Get started today!" robots="index, follow" data-sentry-element="Helmet" data-sentry-source-file="index.tsx" />

      {(treatment === SplitTreatments.Control || treatment === SplitTreatments.Off) && <WellnessPlansPageContainer />}

      {treatment === SplitTreatments.On && <WellnessPlansPageContainerV2 />}

    </>;
};
export default Index;